// #2713: slim, non-blocking bar at the top when a section could not load because a deploy replaced its file. The screen under it keeps working. Reloads ONLY on his tap
// (the place he was is saved and restored); Dismiss hides it for this page load.
import React, { useEffect, useState } from 'react';
import Button from './Button';
import { onChunkFailed } from '../lib/lazyRetry';
import { reloadNow } from '../lib/appUpdate';

export default function StaleBanner() {
  const [show, setShow] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => onChunkFailed(() => setShow(true)), []);
  if (!show || dismissed) return null;
  return (
    <div role="status" data-testid="stale-banner" style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 450, background: '#fff', borderBottom: '1px solid var(--gov-slate-300)', padding: '6px 12px', display: 'flex', alignItems: 'center', gap: 10, justifyContent: 'center', flexWrap: 'wrap' }}>
      <span style={{ fontSize: 13, color: 'var(--gov-text-primary)' }}>Charlie was updated and part of this screen could not load.</span>
      <Button size="sm" variant="primary" color="var(--gov-slate-700)" onClick={() => reloadNow()}>Reload</Button>
      <Button size="sm" variant="secondary" onClick={() => setDismissed(true)}>Dismiss</Button>
    </div>
  );
}
